import { i18n } from '@/shared/i18n';

/**
 * An artifact's `name` is persisted, and both this app and `apps/api` write the
 * generic widget names below into it, so the stored value has to stay English on
 * every writer. Translation therefore happens on read, keyed by the stored name;
 * anything unrecognised (a user's filename, a name a newer agent writes) passes
 * through untouched.
 */
const LABEL_KEY_BY_NAME = {
  'Copy Generation Widget': 'common:artifact.artifactDisplayName.copyGenerationWidget',
  'Email Flow Widget': 'common:artifact.artifactDisplayName.emailFlowWidget',
  'Ideation Widget': 'common:artifact.artifactDisplayName.ideationWidget',
  'Image Generation Widget': 'common:artifact.artifactDisplayName.imageGenerationWidget',
  'Video Generation Widget': 'common:artifact.artifactDisplayName.videoGenerationWidget',
} as const;

// A Map keyed by `string`: any stored name has to be lookupable, while the value side
// keeps the key union `i18n.t` type-checks against.
const LABEL_KEYS = new Map<string, (typeof LABEL_KEY_BY_NAME)[keyof typeof LABEL_KEY_BY_NAME]>(
  Object.entries(LABEL_KEY_BY_NAME),
);

export function getArtifactDisplayName(name: string): string {
  const key = LABEL_KEYS.get(name);
  return key ? i18n.t(key) : name;
}
